<template>
  <myDialog :isDialog="isDialog" :title="isEdit ? '分配组别' : '人工签到'" :width="'500px'" @handleClose="handleClose">
    <template slot="content">
      <el-form :model="formData" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formData.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idNumber">
          <el-input v-model="formData.idNumber" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="分组" prop="workInjuryCategoryCode">
          <el-select v-model="formData.workInjuryCategoryCode" placeholder="请选择分组" @change="handleCategoryChange" style="width: 100%;">
            <el-option
              v-for="item in groupList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </template>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确定</el-button>
    </template>
  </myDialog>
</template>

<script>
import { addSign, updateSign } from '@/api/industrialInjury/sign'
import { getListByDictType } from '@/api/sys/dictData'

export default {
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        name: '',
        idNumber: '',
        phone: '',
        workInjuryCategoryCode: '',
        workInjuryCategoryName: ''
      },
      groupList: [],
      loading: false,
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idNumber: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        workInjuryCategoryCode: [
          { required: true, message: '请选择分组', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getGroupList()
  },
  watch: {
    editData: {
      handler(newVal) {
        if (newVal && this.isEdit) {
          this.formData = {
            id: newVal.id || '',
            name: newVal.name || '',
            idNumber: newVal.idNumber || '',
            phone: newVal.phone || '',
            workInjuryCategoryCode: newVal.workInjuryCategoryCode || '',
            workInjuryCategoryName: newVal.workInjuryCategoryName || ''
          }
        }
      },
      immediate: true,
      deep: true
    },
    isDialog(val) {
      if (!val && !this.isEdit) {
        this.resetForm()
      }
    }
  },
  methods: {
    async getGroupList() {
      const res = await getListByDictType('industrial_injury_work_injury_category')
      if (res?.code === 200) {
        this.groupList = res.data || []
      }
    },
    handleCategoryChange(value) {
      const group = this.groupList.find(item => item.dictValue === value)
      if (group) {
        this.formData.workInjuryCategoryName = group.dictLabel
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          const api = this.isEdit ? updateSign : addSign
          const submitData = {
            ...this.formData,
            signType: this.isEdit ? this.formData.signType : '3'
          }
          api(submitData).then(res => {
            if (res && res.code === 200) {
              this.$message.success(this.isEdit ? '分配成功' : '签到成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          }).catch(err => {
            console.error('请求出错', err)
            this.$message.error('操作失败')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    handleClose() {
      this.$emit('handleClose')
      this.$refs.form && this.$refs.form.resetFields()
      this.resetForm()
    },
    resetForm() {
      this.formData = {
        name: '',
        idNumber: '',
        phone: '',
        workInjuryCategoryCode: '',
        workInjuryCategoryName: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
